import { PersonAddIcon, ProductAddIcon, PaymentFilledIcon, ExportIcon, EmailIcon } from "@shopify/polaris-icons";

const config = (cms) => {
  return {
    "/invitation": [
      {
        caption: cms("common.actions.invitation.caption.manage"),
        label: cms("common.actions.invitation.label.manage"),
        link: "/providers/add",
        icon: EmailIcon,
      },
    ],
    "/orders": [
      {
        caption: cms("common.actions.orders.caption.export"),
        id: "exportOrder",
        label: cms("common.actions.orders.label.export"),
        link: "/orders",
        icon: ExportIcon,
      },
    ],
    "/payments": [
      {
        caption: cms("common.actions.payments.caption.export"),
        id: "exportPayment",
        label: cms("common.actions.payments.label.export"),
        link: "/payments",
        icon: ExportIcon,
      },
      {
        caption: cms("common.actions.payments.caption.autoPayouts"),
        id: "automaticPayouts",
        label: cms("common.actions.payments.label.autoPayouts"),
        link: "/payouts",
        icon: PaymentFilledIcon,
      },
    ],
    "/products": [
      {
        caption: cms("common.actions.products.caption.add"),
        id: "addProduct",
        label: cms("common.actions.products.label.add"),
        link: "/products/add",
        icon: ProductAddIcon,
      },
    ],
    "/providers": [
      {
        caption: cms("common.actions.vendors.caption.add"),
        id: "addProvider",
        label: cms("common.actions.vendors.label.add"),
        link: "/providers/add",
        icon: PersonAddIcon,
      },
    ],
  };
};

export default config;
